"use client";

import { useState } from "react";
import BugReportList from "./BugReportList";
import BugReportDetail from "./BugReportDetail";

const mockBugReports = [
  {
    id: "bug-1",
    username: "john_doe",
    email: "john@example.com",
    bugType: "Visual/UI Issue",
    severity: "critical",
    details:
      "The checkout button disappears when I try to complete my purchase on mobile devices.",
    criticalReason:
      "Users cannot complete purchases, directly impacting revenue.",
    attachments: [{ name: "checkout-bug.png", url: "/placeholder-52oyc.png" }],
    date: "2023-05-14T10:30:00Z",
    status: "open",
  },
  {
    id: "bug-2",
    username: "sarah_smith",
    email: "sarah@example.com",
    bugType: "Functionality Issue",
    severity: "high",
    details:
      "Search results are not displaying correctly when filtering by price range.",
    criticalReason: "",
    attachments: [{ name: "search-bug.jpg", url: "/placeholder-q9syu.png" }],
    date: "2023-05-13T14:45:00Z",
    status: "in-progress",
  },
  {
    id: "bug-3",
    username: "mike_johnson",
    email: "mike@example.com",
    bugType: "Performance Issue",
    severity: "medium",
    details:
      "Game page takes too long to load when there are more than 20 items in the cart.",
    criticalReason: "",
    attachments: [],
    date: "2023-05-12T09:15:00Z",
    status: "resolved",
  },
  {
    id: "bug-4",
    username: "lisa_wong",
    email: "lisa@example.com",
    bugType: "Security Issue",
    severity: "critical",
    details: "Personal information is visible in the URL after login.",
    criticalReason:
      "This exposes sensitive user data and could lead to security breaches.",
    attachments: [
      { name: "security-issue.png", url: "/placeholder-fg77d.png" },
    ],
    date: "2023-05-11T16:20:00Z",
    status: "open",
  },
  {
    id: "bug-5",
    username: "alex_garcia",
    email: "alex@example.com",
    bugType: "Other",
    severity: "low",
    details:
      "The tooltip on the help icon doesn't disappear after clicking elsewhere on the page.",
    criticalReason: "",
    attachments: [],
    date: "2023-05-10T11:05:00Z",
    status: "open",
  },
];

export default function BugInfo() {
  const [selectedBug, setSelectedBug] = useState(null);
  const [activeTab, setActiveTab] = useState("all");

  const openBugs = mockBugReports.filter((bug) => bug.status === "open").length;
  const resolvedBugs = mockBugReports.filter(
    (bug) => bug.status === "resolved"
  ).length;

  const filteredBugs =
    activeTab === "all"
      ? mockBugReports
      : mockBugReports.filter((bug) => bug.status === activeTab);

  return (
    <div className="admin-container">
      <div className="admin-header">
        <div>
          <h1>Bug Report Management</h1>
          <p>View and manage reported bugs from users</p>
        </div>
      </div>

      <div className="stats-container">
        <StatCard
          title="TOTAL REPORTS"
          value={mockBugReports.length}
          color="#4f46e5"
          description="All bug reports"
        />
        <StatCard
          title="OPEN BUGS"
          value={openBugs}
          color="#ef4444"
          description="Waiting for review"
        />
        <StatCard
          title="RESOLVED"
          value={resolvedBugs}
          color="#10b981"
          description="Fixed and verified"
        />
      </div>

      <div className="content-container">
        <div className="bug-list-container">
          <div className="tabs">
            {["all", "open", "resolved"].map((tab) => (
              <button
                key={tab}
                className={activeTab === tab ? "tab-active" : ""}
                onClick={() => setActiveTab(tab)}
              >
                {tab === "all"
                  ? "All Reports"
                  : tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>

          <BugReportList
            bugs={filteredBugs}
            selectedBugId={selectedBug?.id || null}
            onSelectBug={setSelectedBug}
          />
        </div>

        <div className="bug-detail-container">
          {selectedBug ? (
            <BugReportDetail bug={selectedBug} />
          ) : (
            <div className="empty-state">
              <NoBugSelectedIcon />
              <h3>No bug report selected</h3>
              <p>Select a bug report from the list to view details</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function StatCard({ title, value, color, description }) {
  return (
    <div className="stat-card">
      <h2>{title}</h2>
      <div className="stat-value" style={{ color }}>
        {value}
      </div>
      <div className="stat-description">{description}</div>
    </div>
  );
}

function NoBugSelectedIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m8 2 1.88 1.88" />
      <path d="M14.12 3.88 16 2" />
      <path d="M9 7.13v-1a3.003 3.003 0 1 1 6 0v1" />
      <path d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6" />
      <path d="M12 20v-9" />
      <path d="M6.53 9C4.6 8.8 3 7.1 3 5" />
      <path d="M6 13H2" />
      <path d="M3 21c0-2.1 1.7-3.9 3.8-4" />
      <path d="M20.97 5c0 2.1-1.6 3.8-3.5 4" />
      <path d="M22 13h-4" />
      <path d="M17.2 17c2.1.1 3.8 1.9 3.8 4" />
    </svg>
  );
}
